<template>
  <div class="errors-box">
    <div class="img-box">
      <img src="@/assets/images/othererrors.png" />
      <div>系统开小差啦</div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$Spin.hide();
  }
};
</script>
<style lang="less" scoped>
.errors-box {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .img-box {
    width: 5.333333rem;
    height: 6.666667rem;
    text-align: center;
    color: #939393;
    font-size: 0.4rem;
    
    img {
      width: 100%;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none; //禁止用户选中
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Share/Errors.vue